// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarComponent_avatar__ELaV3"};